import React from 'react';

export default function OfficeFlyer() {
    return (
        // The outer div centers the flyer on screen. The inner div is exactly A3 size (297mm x 420mm).
        <div className="min-h-screen bg-gray-200 flex justify-center py-10 print:py-0 print:bg-white" dir="rtl">

            <div className="bg-white w-[297mm] h-[420mm] shadow-2xl print:shadow-none relative flex flex-col overflow-hidden">

                {/* --- HEADER --- */}
                <div className="bg-blue-900 text-white text-center py-8 px-8">
                    <h1 className="text-6xl font-bold mb-3 tracking-tight">משרד פרימיום להשכרה</h1>
                    <p className="text-3xl text-blue-200 font-light">מוכן לכניסה מיידית • מיקום מנצח</p>
                </div>

                {/* --- IMAGE GALLERY (Updated for 7 Images) --- */}
                {/* Changed to grid-rows-3 to accommodate 6 small images under the main one */}
                <div className="flex-none h-[170mm] bg-gray-100 grid grid-cols-3 grid-rows-3 gap-2 p-4">

                    {/* Top Large Image (Spans all 3 columns) */}
                    <div className="col-span-3 row-span-1 bg-gray-300 relative overflow-hidden rounded-t-xl">
                        <img src="/office/office1.jpg" alt="משרד 1" className="object-cover w-full h-full" onError={(e) => { e.target.src = 'https://via.placeholder.com/1200x400?text=Main+Office+Image'; }} />
                    </div>

                    {/* Middle Row (3 Images) */}
                    <div className="bg-gray-300 relative overflow-hidden">
                        <img src="/office/office2.jpg" alt="משרד 2" className="object-cover w-full h-full" onError={(e) => { e.target.src = 'https://via.placeholder.com/400x400?text=Room+1'; }} />
                    </div>
                    <div className="bg-gray-300 relative overflow-hidden">
                        <img src="/office/office3.jpg" alt="משרד 3" className="object-cover w-full h-full" onError={(e) => { e.target.src = 'https://via.placeholder.com/400x400?text=Open+Space'; }} />
                    </div>
                    <div className="bg-gray-300 relative overflow-hidden">
                        <img src="/office/office4.jpg" alt="משרד 4" className="object-cover w-full h-full" onError={(e) => { e.target.src = 'https://via.placeholder.com/400x400?text=Kitchen'; }} />
                    </div>

                    {/* Bottom Row (3 Images) */}
                    <div className="bg-gray-300 relative overflow-hidden rounded-br-xl">
                        <img src="/office/office5.jpg" alt="משרד 5" className="object-cover w-full h-full" onError={(e) => { e.target.src = 'https://via.placeholder.com/400x400?text=Room+2'; }} />
                    </div>
                    <div className="bg-gray-300 relative overflow-hidden">
                        <img src="/office/office6.jpg" alt="משרד 6" className="object-cover w-full h-full" onError={(e) => { e.target.src = 'https://via.placeholder.com/400x400?text=Room+3'; }} />
                    </div>
                    <div className="bg-gray-300 relative overflow-hidden rounded-bl-xl">
                        <img src="/office/office7.jpg" alt="משרד 7" className="object-cover w-full h-full" onError={(e) => { e.target.src = 'https://via.placeholder.com/400x400?text=Room+4'; }} />
                    </div>

                </div>

                {/* --- FEATURES SECTION --- */}
                <div className="flex-grow px-12 py-8 flex flex-col justify-center">
                    <div className="grid grid-cols-2 gap-x-12 gap-y-10">

                        <div className="flex items-start gap-5">
                            <div className="text-6xl border-b-4 border-blue-900 pb-2">📐</div>
                            <div>
                                <h3 className="font-bold text-3xl text-blue-900 mb-1">שטח המשרד</h3>
                                <p className="text-2xl text-gray-700">86.29 מ"ר (64 מ"ר נטו)</p>
                            </div>
                        </div>

                        <div className="flex items-start gap-5">
                            <div className="text-6xl border-b-4 border-blue-900 pb-2">🏢</div>
                            <div>
                                <h3 className="font-bold text-3xl text-blue-900 mb-1">חלוקת פנים</h3>
                                <p className="text-2xl text-gray-700">4 חדרים, חלל עבודה פתוח ומטבחון</p>
                            </div>
                        </div>

                        <div className="flex items-start gap-5">
                            <div className="text-6xl border-b-4 border-blue-900 pb-2">🏙️</div>
                            <div>
                                <h3 className="font-bold text-3xl text-blue-900 mb-1">קומה ונוף</h3>
                                <p className="text-2xl text-gray-700">קומה 5, נוף מדהים ופתוח</p>
                            </div>
                        </div>

                        <div className="flex items-start gap-5">
                            <div className="text-6xl border-b-4 border-blue-900 pb-2">❄️</div>
                            <div>
                                <h3 className="font-bold text-3xl text-blue-900 mb-1">מיזוג אוויר</h3>
                                <p className="text-2xl text-gray-700">6 מזגנים נפרדים לשליטה בכל חלל</p>
                            </div>
                        </div>

                        <div className="flex items-start gap-5 col-span-2">
                            <div className="text-6xl border-b-4 border-blue-900 pb-2">📞</div>
                            <div>
                                <h3 className="font-bold text-3xl text-blue-900 mb-1">מערכת תקשורת ואינטרקום</h3>
                                <p className="text-2xl text-gray-700">עמדה ראשית + 5 שלוחות נפרדות (שלוחה מובנית בכל חדר)</p>
                            </div>
                        </div>

                    </div>
                </div>

                {/* --- FOOTER / CONTACT / QR CODE --- */}
                <div className="bg-gray-900 text-white p-10 flex items-center justify-between">

                    <div className="flex flex-col gap-4">
                        <h2 className="text-4xl font-bold text-yellow-400 mb-2">לפרטים ותיאום סיור:</h2>
                        <div className="flex items-center gap-4 text-3xl font-mono" dir="ltr">
                            <span dir="rtl">📞</span> 052-4874031
                        </div>
                        <div className="flex items-center gap-4 text-2xl font-mono text-gray-300" dir="ltr">
                            <span dir="rtl">✉️</span> majd@alumnawatha.com
                        </div>
                    </div>

                    <div className="bg-white p-4 rounded-xl flex flex-col items-center shadow-lg">
                        {/* Automatically generates the QR Code for your specific domain */}
                        <img src="https://api.qrserver.com/v1/create-qr-code/?size=200x200&data=https://www.alumnawatha.com/office" alt="QR Code" className="w-36 h-36 mb-3" />
                        <p className="text-blue-900 font-bold text-center text-lg leading-tight">סרקו לסיור<br />ולפרטים נוספים</p>
                    </div>

                </div>

            </div>
        </div>
    );
}